function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "current",
  strokeWidth: 10,
  strokeMiterlimit: 10,
  d: "M186.86,97.451c0-15.922-12.099-29.02-27.604-30.6 c0.24-1.553,0.367-3.144,0.367-4.763c0-16.99-13.772-30.763-30.762-30.763c-4.478,0-8.725,0.964-12.561,2.684 C110.217,17.096,94.038,5,75.031,5C50.813,5,31.18,24.634,31.18,48.852c0,6.362,1.365,12.401,3.804,17.857 C18.354,67.125,5,80.724,5,97.451c0,16.989,13.771,30.763,30.762,30.763h123.862v-0.207 C174.953,126.257,186.86,113.248,186.86,97.451z"
});

var SvgHumidity = function SvgHumidity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "192px",
    height: "133px",
    viewBox: "0 0 192 133",
    enableBackground: "new 0 0 192 133",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHumidity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/humidity.601237b6.svg";
export { ForwardRef as ReactComponent };